export default {
  'pages.todo.adminTitle': 'Todo Management',
  'pages.todo.consoleTitle': 'My Todos',
  'pages.todo.adminDesc': 'View and manage all users\' todo items, filter by user / keyword / status.',
  'pages.todo.consoleDesc': 'Manage todo items owned by the current account.',
  'pages.todo.new': 'New Todo',
  'pages.todo.colTitle': 'Title',
  'pages.todo.colContent': 'Content',
  'pages.todo.colPriority': 'Priority',
  'pages.todo.colRemindAt': 'Remind At',
  'pages.todo.colRepeat': 'Repeat',
  'pages.todo.colStatus': 'Status',
  'pages.todo.colSource': 'Source',
  'pages.todo.colUser': 'Owner',
  'pages.todo.colUserIdFilter': 'User ID',
  'pages.todo.colCreatedAt': 'Created At',
  'pages.todo.colActions': 'Actions',
  'pages.todo.complete': 'Complete',
  'pages.todo.edit': 'Edit',
  'pages.todo.delete': 'Delete',
  'pages.todo.confirmDelete': 'Delete this todo?',
  'pages.todo.confirm': 'OK',
  'pages.todo.cancel': 'Cancel',
  'pages.todo.created': 'Created',
  'pages.todo.updated': 'Updated',
  'pages.todo.completed': 'Completed',
  'pages.todo.completedRepeat': 'Completed this round; next reminder scheduled',
  'pages.todo.deleted': 'Deleted',
  'pages.todo.opFail': 'Operation failed',
  'pages.todo.titleRequired': 'Please enter a title',
  'pages.todo.remindAtPlaceholder': 'Pick remind time (local timezone)',
  'pages.todo.targetUser': 'Owner',
  'pages.todo.targetUserTip': 'Leave empty to assign to the current account',
  'pages.todo.userIdPlaceholder': 'Enter user ID to filter',
  'pages.todo.colUsernameFilter': 'Username',
  'pages.todo.colDeviceFilter': 'Device MAC',
  'pages.todo.colDevice': 'Device',
  'pages.todo.colKeyword': 'Keyword',
  'pages.todo.keywordPlaceholder': 'Search title or content',
  'pages.todo.deviceTip': 'Select an associated device (optional)',
  'pages.todo.deviceSelectPlaceholder': 'Select device (name / MAC)',
  'pages.todo.noDevice': 'No device found',
  'pages.todo.usernamePlaceholder': 'Enter username to filter',
  'pages.todo.devicePlaceholder': 'Enter device MAC to filter',
  'pages.todo.searchUserPlaceholder': 'Search user by username',
  'pages.todo.noUserFound': 'No user found',

  // Priority / source / repeat / status labels
  'pages.todo.priority.normal': 'Normal',
  'pages.todo.priority.important': 'Important',
  'pages.todo.priority.urgent': 'Urgent',
  'pages.todo.source.user': 'User',
  'pages.todo.source.admin': 'Admin',
  'pages.todo.source.device': 'Device',
  'pages.todo.repeat.none': 'No repeat',
  'pages.todo.repeat.daily': 'Daily',
  'pages.todo.repeat.weekly': 'Weekly',
  'pages.todo.repeat.monthly': 'Monthly',
  'pages.todo.status.todo': 'To-do',
  'pages.todo.status.done': 'Done',
};
